export default __webpack_public_path__ + "static/media/colored-offer-delete-icon.c8531d9f.svg";